"use client";

import { usePathname } from "next/navigation";

export function LayoutShell({
  navbar,
  footer,
  bottomNav,
  hasBottomNav,
  children,
}: {
  navbar: React.ReactNode;
  footer: React.ReactNode;
  bottomNav?: React.ReactNode;
  hasBottomNav?: boolean;
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isLanding = pathname === "/";

  return (
    <>
      {!isLanding && navbar}
      <main
        id="main"
        data-app-chrome={!isLanding || undefined}
        data-bottom-nav={hasBottomNav && !isLanding || undefined}
        className="app-main min-h-screen"
      >
        {children}
      </main>
      {!isLanding && footer}
      {bottomNav}
    </>
  );
}
